import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogTitle, MatDialogContent, MatDialogActions, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ProjectIdInputDialogComponent } from 'src/app/project-id-input-dialog/project-id-input-dialog.component';
import { urlSafeStringValidator } from '../urlSafeStringValidator';
import { uniqueIdRequirement } from './uniqueIdRequirement';

@Component({
  selector: 'app-new-publication-configuration-dialog',
  imports: [MatInputModule,
    MatFormFieldModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    ReactiveFormsModule,
    CommonModule,
    MatInputModule],
  templateUrl: './new-publication-configuration-dialog.component.html',
  styleUrl: './new-publication-configuration-dialog.component.scss'
})
export class NewPublicationConfigurationDialogComponent {
  form: FormGroup = new FormGroup({});

  constructor(
    public dialogRef: MatDialogRef<ProjectIdInputDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public groupWithLists: FormArray,
    private fb: FormBuilder,
  ) {
  }

  ngOnInit(): void {
    this.form.addControl('text', this.fb.control<string>('', [Validators.required, urlSafeStringValidator(), uniqueIdRequirement(this.groupWithLists)]));
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value.text);
    }
  }

  get id() {
    return this.form.get('text');
  }

  static idValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const validStringPattern = /^[a-zA-Z0-9-]*$/;
      const isValid = validStringPattern.test(control.value);
      return isValid ? null : { invalidString: true };
    };
  }
}
